/*
 * Navigation scripts.
 *
 * @author Julian Pollak <j.pollak@fruitcake.ch>
 * @copyright 2017-2019 by Fruitcake Websolutions (fruitcake.ch)
 */

!function ($) {
    var $navbar = false;
    var $dropdowns = false;

    var body_offset = 0;
    var header_height = 0;
    var desktop_breakpoint = 0;

    // Smooth scroll
    function smooth_scroll(urlString, animate) {
        // multipurpose function. use as string hash argument or jQuery-on callback.
        urlString = typeof (urlString) === 'string' ? urlString : $(this).attr('href');
        animate = typeof (animate) === 'undefined' ? true : animate;

        var urlElement = document.createElement('a');
        urlElement.setAttribute('href', urlString);

        var pathname = /^\//.test(urlElement.pathname) ? urlElement.pathname : '/' + urlElement.pathname;

        // check if the link points to the the same page at all
        if (pathname === window.location.pathname &&
            urlElement.protocol === window.location.protocol &&
            urlElement.hostname === window.location.hostname &&
            urlElement.hash !== '') {

            var $target = $(urlElement.hash);
            if ($target.length) {
                var offset = 0;
                if (window.innerWidth >= desktop_breakpoint) {
                    offset = body_offset;
                }
                offset = ($target.offset().top - offset);
                if (animate) {
                    $('html, body').animate({scrollTop: offset}, 650);
                } else {
                    $(window).scrollTop(offset);
                }
            }
        }
    }

    $(function () {
        var $body = $('body');
        var $root = $(':root');
        $navbar = $('#mgd-navbar');
        $dropdowns = $('.nav-item.dropdown');

        body_offset = $body.offset().top;
        header_height = parseFloat($root.css('--mgd-navbar-scroll-height')) * parseFloat(getComputedStyle(document.documentElement).fontSize); // variable in rem
        desktop_breakpoint = parseInt($root.css('--mgd-breakpoint-desktop')); // variable in px

        // Header collapse
        $body.waypoint(function (direction) {
            $(this.element).toggleClass('mgd-page-scrolled', direction === 'down');
        }, {
            offset: -(header_height),
        });

        // Navigation on non-touch devices: use hover intent, reenable main menu link clicks
        if (!('ontouchstart' in document.documentElement)) {
            $dropdowns.hoverIntent({
                sensitivity: 4,
                interval: 50,
                timeout: 150,
                over: function (event) {
                    $(this).find('.dropdown-menu').addClass('show');
                },
                out: function (event) {
                    $(this).find('.dropdown-menu').removeClass('show');
                }
            });

            // Fix target=_blank link clicks
            $dropdowns.on('click', 'a', function (event) {
                if (!$(event.target).attr('target') || $(event.target).attr('target') !== '_blank') {
                    window.location.href = $(this).attr('href');
                }
            });
        }
        // Navigation on touch devices: copy main menu entry to submenu
        else {
            $dropdowns.each(function () {
                var clone = $(this).find('.nav-link').clone();
                $(this).find('.nav-link').attr('href', '#');
                $(clone).removeClass('nav-link').removeClass('dropdown-toggle').removeClass('active').addClass('dropdown-item');
                $(clone).removeAttr('data-toggle');
                $(clone).removeAttr('aria-expanded');
                $(this).find('.dropdown-menu').prepend(clone);
            });
        }

        // make the page scroll button use smooth scrolling
        $('.mgd-page-scroll-button').on('click', 'a', smooth_scroll);
    });
}(jQuery);
